<template>
    <div class="no-repair">
      <img src="/images/order/diagnosis-no-repair.png" alt="" />
      <div class="f32 text">很遗憾我们尽力了~</div>
      <div v-for='(item,index) in JSON.parse(model.goodsCuringServiceRepairPointBoList[0].goodsDiagnoseBoList[0].speech)' :key='index'>
        <div class="desc f28 grey9" v-if='item.diagnosis'>{{item.diagnosis}}</div>
        <div class="desc f28 grey9" v-if='item.explanation'>{{item.explanation}}</div>
        <div class="desc f28 grey9" v-if='item.repairation'>{{item.repairation}}</div>
        <div class="desc f28 grey9" v-if='item.prevenience'>{{item.prevenience}}</div>

      </div>
    </div>
</template>

<script>
  export default {
    name: 'noRepair',
    props: {
      model: {
        type: Object,
        default: () => {}
      }
    },
    created(){
      console.log(this.model.goodsCuringServiceRepairPointBoList[0].goodsDiagnoseBoList[0].speech)
    },
  
  }
</script>

<style scoped lang="scss">
  .no-repair{
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 374px;
      height: 400px;
      margin-top: 100px;
    }
    .desc{
      line-height: 40px;
      width: 690px;
      text-align: center;
      margin-top: 20px;
    }
    .text{
      line-height: 44px;
      margin-top: 50px;
      margin-bottom: 30px;
    }
  }
</style>
